import Cookies from "js-cookie";
import { checkAuth } from "api";
import { setCookie, removeAllCookie, getCookie } from "utils/StorageVariables";
import { setUserId } from 'utils/amplitude';
import { ActionTypes } from "./types";
import { IsUser } from "Redux/User/action";
import { isDigitalOcean } from "config";

async function getCheckAuthLocal() {
  return new Promise((resolve) => {
    setTimeout(() => {
      const rawData = Cookies.get('token-local');

      if (!rawData || typeof rawData === "undefined") {
        resolve({
          data: {
            authenticated: false
          }
        });

        return;
      }

      const data = JSON.parse(rawData);

      resolve({
        data: {
          authenticated: true,
          ...data
        }
      });
    }, 150); // Simulate response time
  });
}

export const CheckAuth = (params) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING, payload: params });

    const { data: results } = (process.env.NODE_ENV === 'development' || isDigitalOcean)
      ? await getCheckAuthLocal()
      : await checkAuth();

    if (results) {
      const data = results.token && results.user
        ? results
        : { token: '', user: {} }

      // Get current token from locally saved cookie
      const currentToken = getCookie("token");

      console.log('🟡 Current Token:', currentToken);

      // Compare tokens and cleanup if they don't match
      if (currentToken && results.token && currentToken !== results.token) {
        // Tokens don't match, perform cleanup
        removeAllCookie();
        console.log('Token mismatch detected. Cleaned up existing data.');
      }

      dispatch({
        type: ActionTypes.SUCCESS,
        payload: data
      });

      if (results.user) {
        dispatch(IsUser(results.user));
        setUserId(results.user.id);
        setCookie("userDetail", JSON.stringify(results.user));
      }

      // Save token into cookie just like userDetail
      if (results.token) {
        setCookie("token", results.token);
      }
    }
  } catch (error) {
    error?.response?.data?.detail?.map((err) => Error(err));
    dispatch({
      type: ActionTypes.ERROR,
      payload: error
    });
  }
};

export const SetToken = token => async (dispatch) => {
  dispatch({
    type: ActionTypes.SET_TOKEN,
    payload: { token }
  });
};

export const RemoveToken = () => async (dispatch) => {
  dispatch({
    type: ActionTypes.REMOVE_TOKEN
  });
};
